@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.Configurations)" class="request-button">Ver Configuraciones</button>

    <button (click)="selectView(views.CreatingConfiguration)" class="request-button">Crear Configuración</button>
  </div>

  <!-- <div class="configuration-searched-container" >
    <div class="configuration-search-information">
      <p class="text-info">Devuelve una Configuración específica (GET).</p>
      <button (click)="getConfiguration()">Buscar Configuración</button>
      <div class="name-input-container" >
        <input type="text" [(ngModel)]="configurationNameToSearch" class="name-input" placeholder="Nombre">
        @if(configurationNotFound) {
          <p class="configuration-not-found">Configuración no encontrado</p>
        }
      </div>
    </div>

    <div class="configuration-searched">
      <p><strong>Nombre: </strong>{{configurationSearched ? configurationSearched.nombre : ''}}</p>
      <p><strong>Valor: </strong>{{configurationSearched ? configurationSearched.valor: ''}}</p>
    </div>
  </div> -->
}

@if(currentView === views.Configurations) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="configurationToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de Configuraciones -->
  <div class="scroll-container">
    <div class="configurations-container">
      @for(configuration of configurations; track configuration.nombre) {
        <div class="configuration" (click)="selectView(views.ConfigurationDetails, configuration)">
          <p>{{configuration.nombre}}</p>
        </div>
      }
    </div>
  </div>
}

<!-- Vista de crear, editar y detalles Configuración -->
@if(currentView === views.ConfigurationDetails ||currentView === views.EditingConfiguration || currentView === views.CreatingConfiguration) {
  <div class="info-configuration-container">
    <h4>{{currentView === views.ConfigurationDetails ? 'Detalles de' : (currentView === views.EditingConfiguration ? 'Editar' : 'Crear')}} Configuración</h4>

    <div class="input-container">
      <label>Nombre:</label>
      <input type="text" class="new-input" [(ngModel)]="newConfiguration.nombre" placeholder="Nombre de configuración"
        [readOnly]="currentView === views.ConfigurationDetails">
    </div>

    <div class="input-container">
      <label>Valor:</label>
      <textarea type="text" class="textarea" [(ngModel)]="newConfiguration.valor" placeholder="Valor de configuración"
        [readOnly]="currentView === views.ConfigurationDetails"></textarea>
    </div>

    <div class="info-buttons">
      <button class="button button-colors"
        (click)="currentView === views.EditingConfiguration ? selectView(views.ConfigurationDetails) : (currentView === views.ConfigurationDetails ? selectView(views.Configurations) : selectView(views.Home))">
        Volver
      </button>

      @if(currentView === views.ConfigurationDetails) {
        <button class="button button-colors" (click)="deleteConfiguration()" [disabled]="!globalService.editing">Eliminar Configuración</button>
      }

      <button class="button button-colors"
        (click)="currentView === views.CreatingConfiguration ? createConfiguration() : (currentView === views.EditingConfiguration ? editConfiguration() : selectView(views.EditingConfiguration))"
        [disabled]="!globalService.editing || (newConfiguration.nombre.length === 0 || newConfiguration.valor.length === 0) || (newConfiguration.nombre === ' ' || newConfiguration.valor === ' ')">
        {{currentView === views.ConfigurationDetails ? 'Editar': 'Confirmar'}}
      </button>
    </div>
  </div>
}